import { BarChart3 } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell,
  AreaChart, Area,
} from "recharts";
import { StatCard, SectionHeader, ChartTooltipContent, PIPE_COLORS, PIPE_LABELS, fmt$ } from "./ReportsShared";

export const PipelineSection = ({ pipeline }) => {
  const pipeData = pipeline.by_status.map((s) => ({
    name: PIPE_LABELS[s.status] || s.status,
    count: s.count,
    volume: s.volume,
    fill: PIPE_COLORS[s.status] || "#64748b",
  }));

  return (
    <section data-testid="section-pipeline" id="section-pipeline">
      <SectionHeader icon={BarChart3} title="Pipeline Overview" subtitle="Transaction funnel by status" />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        {pipeline.by_status.map((s) => (
          <StatCard
            key={s.status}
            icon={BarChart3}
            label={PIPE_LABELS[s.status] || s.status}
            value={s.count}
            sub={fmt$(s.volume)}
            color={PIPE_COLORS[s.status] || "#64748b"}
          />
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Card className="card-surface" data-testid="pipeline-bar-chart">
          <CardHeader className="py-3 px-5">
            <CardTitle className="text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--t-text-muted)" }}>Pipeline by Status</CardTitle>
          </CardHeader>
          <CardContent className="px-2 pb-4">
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={pipeData} barSize={36}>
                <CartesianGrid strokeDasharray="3 3" stroke="var(--t-border)" />
                <XAxis dataKey="name" tick={{ fontSize: 11, fill: "var(--t-text-muted)" }} />
                <YAxis tick={{ fontSize: 11, fill: "var(--t-text-muted)" }} />
                <Tooltip content={<ChartTooltipContent />} />
                <Bar dataKey="count" name="Transactions" radius={[4, 4, 0, 0]}>
                  {pipeData.map((entry) => (
                    <Cell key={entry.name} fill={entry.fill} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
        <Card className="card-surface" data-testid="pipeline-monthly-chart">
          <CardHeader className="py-3 px-5">
            <CardTitle className="text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--t-text-muted)" }}>Transactions Created (Monthly)</CardTitle>
          </CardHeader>
          <CardContent className="px-2 pb-4">
            <ResponsiveContainer width="100%" height={220}>
              <AreaChart data={pipeline.monthly_created}>
                <CartesianGrid strokeDasharray="3 3" stroke="var(--t-border)" />
                <XAxis dataKey="month" tick={{ fontSize: 11, fill: "var(--t-text-muted)" }} />
                <YAxis tick={{ fontSize: 11, fill: "var(--t-text-muted)" }} allowDecimals={false} />
                <Tooltip content={<ChartTooltipContent />} />
                <Area type="monotone" dataKey="count" name="Created" stroke="#2563eb" fill="#2563eb" fillOpacity={0.15} strokeWidth={2} />
              </AreaChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
